import { PageTokenPagination } from "src/api/public-types";

export type AccessLogUserType = "MEMBER" | "VISITOR";
export type AccessLogSearchType = "email" | "nickname" | "memberNo" | "deviceName" | "contractVisitorId";
export type AccessLogEventGroup = "ACCESS_SUCCESS" | "ACCESS_FAILURE" | "ACCESS_REJECTED";

/* 화면 URL 쿼리로 관리하는 검색 조건. 페이지 위치는 포함하지 않음 */
export interface AccessLogSearchParams {
  startDate?: string;
  endDate?: string;
  userType?: AccessLogUserType;
  searchType?: AccessLogSearchType | "";
  searchValue?: string;
  accessType?: string;
  eventGroup?: AccessLogEventGroup | "";
}

/* RAD54 요청 */
export interface AccessLogPageTokenParams extends AccessLogSearchParams {
  startDate: string;
  endDate: string;
  pageToken?: string;
  pageSize?: number; // default 20, max 400
}

/* RAD54 응답 */
export interface AccessLogPageTokenResponse {
  logs: AccessLogsResponse[];
  pagination: PageTokenPagination;
}

export interface AccessLogsResponse {
  id?: string;
  index?: string;
  phoneNumber?: string;
  email?: string;
  nickname?: string;
  userId?: string;
  deviceName?: string;
  deviceId?: string;
  eventName?: string;
  eventCode?: string;
  eventGroup?: string;
  datetime?: string;
  accessGroupIds?: string[];
  userType?: string;
  accessType?: string;
  contractManageIds?: string[];
  [key: string]: any; // 동적 필드를 위한 인덱스 시그니처
}

export const findAccessTypeToString = (accessType: string) => {
  switch (accessType) {
    case "MEMBER_AUTHENTICATION":
      return "QR(Offline)";
    case "MEMBER_MUTABLE":
      return "QR(Member)";
    case "VISITOR_MUTABLE":
      return "QR(Visitor)";
    case "MEMBER_FIXED":
      return "RF(Member)";
    case "VISITOR_FIXED":
      return "RF(Visitor)";
    case "MEMBER_FIXED_FACE":
      return "Face";
    case "KAKAO_QR":
      return "QR(Kakao)";
    case "MEMBER_MOBILE":
      return "Mobile Card";
    default:
      return "-";
  }
};

// 목록 엑셀 다운로드 헤더
export const accessRecordHeaders = [
  { label: "이벤트 발생일시", key: "datetime" },
  { label: "이벤트", key: "eventName" },
  { label: "인증 유형", key: "accessType" },
  { label: "장치명", key: "deviceName" },
  { label: "계약명", key: "contractName" },
  { label: "이용자 닉네임", key: "nickname" },
  { label: "이메일", key: "email" },
  { label: "회원번호", key: "userId" },
  { label: "방문자 ID", key: "userId2" },
];
